import React from 'react';
import { TextInputStyledSuffix } from 'src/view/components/input';

/*
 * `baseDomain` comes from the API via the landing page payload. Rendering no
 * suffix when it is missing is deliberate: see src/utils/landing-page-domain.js.
 */
const DomainInput = ({ baseDomain, ...props }) => (
  <TextInputStyledSuffix
    {...props}
    suffix={baseDomain ? `.${baseDomain}` : ''}
  />
);

export default DomainInput;
